const light = '#f4f4f4'
const primary = '#1F5869'
const secondary = '#C8E2E3'
const warning = '#77C8BF'
const info = '#153F4D'

const colors = {
  light,
  primary,
  secondary,
  warning,
  info
}
export default colors
